export default __webpack_public_path__ + "static/media/info.03158b04.svg";